import React, { memo } from "react";
import DownloadIconBase from "../../../DownloadIcon";
import IconSrc from "icons/download.svg";

const DownloadIcon = (props) => {
  return <DownloadIconBase icon={IconSrc} loaderColor="white" {...props} />;
};

export default memo(DownloadIcon);
